export const getInfo = data => {
  let { dealer } = data
  let info = [
    {
      key: '经销商',
      value: '【到店】轮胎快修服务'
    },
    {
      key: '经销商',
      value: dealer.name
    },
    {
      key: '经销商电话',
      value: dealer.tel
    },
    {
      key: '经销商地址',
      value: dealer.address
    },
    {
      key: '车主姓名',
      value: data.name
    },
    {
      key: '手机号',
      value: data.mobile
    },
    {
      key: '车牌号',
      value: data.plate_number
    },
    {
      key: '轮胎照片',
      type: 'img',
      value: []
    },
    {
      key: '厂商建议零售价*',
      value: '¥1700.00'
    },
    {
      key: '经销商改后价',
      value: '--'
    },
    {
      key: '优惠券',
      value: '-¥100.00'
    },
    {
      key: '参考实付',
      value: '¥1600.00'
    }
  ]
  for (const item of data.tyre_images) {
    info[7].value.push(item.url)
  }
  return info
}
